import { useEffect, useState } from 'react';
import Burger from '../Burger/Burger';
import styles from './Header.module.scss';
import MainLogo from './mainLogo/MainLogo';
import Nav from './nav/Nav';
import classnames from 'classnames';
import SliderMission from '../Slider-mission/SliderMission';
import PageLogo from '../logo/PageLogo/PageLogo';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';

const Header = () => {
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isPromo, setIsPromo] = useState(false);
  const [isMain, setIsMain] = useState(false);
  const location = useLocation();

  const isMasterPlanDetail = useSelector((state) => state.page.isMasterPlanDetail);

  useEffect(() => {
    const path = location.pathname;

    if (path === '/') {
      setIsMain(true);
      setIsPromo(true);
    } else {
      // Все остальные страницы (включая /masterplan) — обычные
      setIsPromo(false);
      setIsMain(false);
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleMenu = () => {
    setIsShowMenu(!isShowMenu);
  };

  return (
    <header
      className={classnames({
        [styles.header]: true,
        [styles.open]: isShowMenu,
        [styles.noPromo]: !isPromo,
        [styles.promo]: isPromo,
        [styles.main]: isMain,
        [styles.masterPlanDetail]: isMasterPlanDetail,
      })}>
      {isPromo || isShowMenu ? <MainLogo isShowMenu={isShowMenu} /> : null}

      <Nav isShowMenu={isShowMenu} isWhiteText={isPromo} toggleMenu={toggleMenu} />
      <Burger isShowMenu={isShowMenu} toggleMenu={toggleMenu} />
      <SliderMission location="menu" />
      {!isShowMenu && isMobile && !isPromo && (
        <div className={styles.after}>
          <PageLogo />
        </div>
      )}
    </header>
  );
};

export default Header;
